<div data-test="quiz" class="view-quiz">
  
  <!-- Header section -->
  <div class="pb-2 mb-4 view-quiz__header" *ngIf="showHeader">
    <!-- Quiz Title -->
    <div class="flex">
      <h1 class="text-20 text-semibold flex-grow">Quiz</h1>
      
      <button *ngIf="!(quizLocked$ | async)" app-pin-button icon="times" size="small" (click)="handleExitClick()">
        <span class="visually-hidden">Exit Quiz</span>
      </button>
    </div>
    
    <app-view-quiz-progress
      class="mt-3"
      [index]="(questionIndex$ | async)"
      [total]="(questionTotal$ | async)"
      *ngIf="(quizSettings$ | async)?.showProgress && (lifecycle$ | async) !== Lifecycle.Review">
    </app-view-quiz-progress>
  </div>

  <!-- Question Section -->
  <form
    [formGroup]="form"
    (submit)="handleSubmit()"
    *ngIf="(lifecycle$ | async) === Lifecycle.Question">

    <app-view-quiz-question
      *ngIf="question$ | async"
      formControlName="question"
      [question]="(question$ | async)">
    </app-view-quiz-question>
      
    <button
        *ngIf="(quizSettings$ | async)?.showSubmit && (lifecycle$ | async) === Lifecycle.Question"
        app-button
        class="w-100"
        buttonType="info"
        [disabled]="!form.valid"
        data-test="questionSubmit">
        <div [ngSwitch]="(question$ | async)?.type">
          <div *ngSwitchCase="quizQuestionType.Instructions">
            {{ (question$ | async)?.nextLabel || defaultNextButtonNext }}
          </div>
          <div *ngSwitchDefault>Submit</div>
        </div>
    </button>
  </form>


  <!-- Answer Section -->
  <ng-container *ngIf="(lifecycle$ | async) === Lifecycle.Explanation">

    <div class="mb-8">
      <app-view-quiz-answer
        [question]="(question$ | async)"
        [answer]="(submission$ | async).answer"
        [summary]="false">
      </app-view-quiz-answer>
    </div>
      
    
    <!-- Navigation -->
    <ng-container [ngSwitch]="hasQuestionsRemaining$ | async">
  
        <!-- next -->
        <button
          app-button
          buttonType="info"
          class="w-100"
          (click)="nextQuestion()"
          *ngSwitchCase="true"
          data-test="questionNextButton">
          {{ (question$ | async)?.nextLabel || defaultNextButtonNext }}
        </button>

        <!-- show summary -->
        <ng-container *ngSwitchDefault>

          <button
            *ngIf="quizReviewEnabled$ | async"
            data-test="quizViewSummaryButton"
            app-button
            buttonType="info"
            class="w-100"
            (click)="handleViewSummaryClick()">
            See Results
          </button>

        </ng-container>

    </ng-container>

  </ng-container>


  <!-- Review Section -->
  <ng-container *ngIf="(lifecycle$ | async) === Lifecycle.Review && (quizReviewEnabled$ | async)">

    <app-view-quiz-review>      
    </app-view-quiz-review>

  </ng-container>

  <!-- Confirmation: for single submission -->
  <div class="text-16 text-bold text-center" *ngIf="!(hasQuestionsRemaining$ | async) && !(quizReviewEnabled$ | async) && !(quizSettings$ | async)?.showExplanation">
    {{ (questions$ | async)?.length === 1 ? 'Answer' : 'Answers'}} submitted
  </div>

</div>
